// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    // {
    //   prop: 'settlementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   method: 'post',
    // },
    // {
    //   prop: 'settlementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.companyCode,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: !ctx.companyCode,
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   method: 'post',
    // },
    {
      name: '供应商',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      disabled: true,
      isMultiple: true,
      span: 7,
      // changeMethod: ctx.changeSupplyChainMethod,
      currentValue: ctx.query?.supplierName,
    },
    // {
    //   name: '结算单状态',
    //   prop: 'settlementStatus',
    //   type: 'select',
    //   options: ctx.dictListMap?.settlementStatus,
    // },
    {
      name: '合同编号',
      prop: 'contractNoStr',
      type: 'input',
      disabled: true,
      span: 7,
    },
    // {
    //   name: '结算单类型',
    //   prop: 'settlementType',
    //   type: 'select',
    //   disabled: true,
    //   options: ctx.dictListMap?.settlementType,
    // },
    {
      name: '结算单编号',
      prop: 'payableSettlementNo',
      type: 'input',
      span: 7,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'payableSettlementNo',
    title: '结算单编号',
    visible: true,
    width: 120,
  },
  {
    field: 'settlementCompanyName',
    title: '公司名称',
    visible: true,
    width: 120,
  },
  {
    field: 'settlementDepartmentName',
    title: '部门',
    visible: true,
    width: 120,
  },
  // {
  //   field: 'settlementBusinessType',
  //   title: '业务类别',
  //   visible: true,
  //   width: 120,
  // },
  {
    field: 'supplierName',
    title: '供应商',
    visible: true,
    width: 120,
  },
  // {
  //   field: 'settlementCenterName',
  //   title: '结算中心',
  //   visible: true,
  //   width: 120,
  // },
  {
    field: 'settlementDate',
    title: '结算日期',
    visible: true,
    width: 120,
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: 120,
  },
  {
    field: 'writeOffPreNum',
    title: '冲销数量',
    width: 150,
    editRender: { name: 'amountRound', attrs: { type: 'number' } },
  },
  {
    field: 'writeOffPreNumTemp',
    title: '剩余可冲销数量',
    width: 120,
  },
  {
    field: 'originalTotalAmount',
    title: '原币结算金额（含税）',
    visible: true,
    width: 120,
  },
  {
    field: 'originalTotalAmountWithoutTax',
    title: '原币结算金额（不含税）',
    visible: true,
    width: 120,
  },
  // {
  //   field: 'domesticTotalAmount',
  //   title: '本币结算金额（含税）',
  //   visible: true,
  //   width: 120,
  // },
  // {
  //   field: 'domesticTotalAmountWithoutTax',
  //   title: '本币结算金额（不含税）',
  //   visible: true,
  //   width: 120,
  // },
  {
    field: 'payableAccountPeriod',
    title: '应付账期',
    visible: true,
    width: 120,
  },
  {
    field: 'projectInitiationNo',
    title: '项目编号',
    visible: true,
    width: 120,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
    width: 120,
  },

  {
    field: 'settlementStatus',
    title: '结算单状态',
    visible: true,
    width: 120,
  },
  {
    field: 'paymentStatus',
    title: '付款状态',
    visible: true,
    width: 120,
  },
  {
    field: 'paidAmount',
    title: '付款金额',
    visible: true,
    width: 120,
  },
  {
    field: 'unpaidAmount',
    title: '未付款金额',
    visible: true,
    width: 120,
  },
  // {
  //   field: 'printFlag',
  //   title: '是否已打印',
  //   visible: true,
  //   width: 120,
  // },
  // {
  //   field: 'salesmanName',
  //   title: '业务员',
  //   visible: true,
  //   width: 120,
  // },
];
export const tableList = [
  {
    id: 1,
    payableSettlementNo: 1111,
    settlementDesc: '说明',
    companyName: 'A',
    departmentName: 'b',
    originalTotalAmount: 1,
    domesticTotalAmount: 1,
    currencyName: 'TEST',
    contractNo: 66666,
    projectInitiationNo: 88888,
    productName: '乐百氏',
  },
  {
    id: 2,
    payableSettlementNo: 2222,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 2,
    domesticTotalAmount: 2,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 3,
    payableSettlementNo: 3333,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 3,
    domesticTotalAmount: 3,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 4,
    payableSettlementNo: 4444,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 4,
    domesticTotalAmount: 4,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 5,
    payableSettlementNo: 5555,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 5,
    domesticTotalAmount: 5,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
];
// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '新建',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  // {
  //   id: 2,
  //   label: '启用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 3,
  //   label: '禁用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'forbid',
  //   },
  // },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  // {
  //   id: 5,
  //   label: '批量导入',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  // {
  //   id: 6,
  //   label: '批准',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'approval',
  //   },
  // },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  {
    id: 8,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];
